// this hook will handle multiple loading events in a component
import { useState } from "react";
const useLoading = () => {
  const [loadingEvents, setLoadingEvents] = useState([]);

  const startLoading = (eventName) => {
    setLoadingEvents((prevEvents) => [...prevEvents, eventName]);
  };

  const stopLoading = (eventName) => {
    setLoadingEvents((prevEvents) =>
      prevEvents.filter((event) => event !== eventName)
    );
  };

  const isLoading = (eventName) => {
    return loadingEvents.includes(eventName);
  };

  const createLoadingFunction = (eventName) => {
    return {
      start: () => startLoading(eventName),
      stop: () => stopLoading(eventName),
      isLoading: () => isLoading(eventName),
    };
  };

  return { createLoadingFunction };
};

export default useLoading;
